import { n as numericRangesExports } from '../../../../../../../../@cimpress-technology/numeric-ranges/dist/numeric-ranges.mjs';
import { RangedAttributeValidationCode } from '../../../../types/ranged-attribute-validation.mjs';

const validateRangeInput = (valueToBeValidated, option, showFormErrors) => {
    if (!valueToBeValidated) {
        if (option.isRequired && showFormErrors) {
            return {
                code: RangedAttributeValidationCode.EMPTY_INPUT,
            };
        }
        return {
            code: RangedAttributeValidationCode.SUCCESS,
        };
    }
    const rangeInformation = new numericRangesExports.Ranges(getRanges(option));
    try {
        const { contains, adjacentValues } = rangeInformation.contains(valueToBeValidated);
        if (!contains) {
            return {
                code: RangedAttributeValidationCode.NOT_IN_RANGE,
                additionalInformation: {
                    adjacentValues,
                },
            };
        }
        else {
            return {
                code: RangedAttributeValidationCode.SUCCESS,
            };
        }
    }
    catch (ex) {
        if (ex instanceof Error) {
            if (ex.message.includes("decimal")) {
                return {
                    code: RangedAttributeValidationCode.UNSUPPORTED_PRECISION,
                };
            }
            else if (ex.message.includes("not a valid input")) {
                return {
                    code: RangedAttributeValidationCode.NOT_A_NUMBER,
                };
            }
        }
        console.error(ex);
        return {
            code: RangedAttributeValidationCode.UNKNOWN_ERROR,
        };
    }
};
const getRanges = (option) => {
    const ranges = [];
    option.choices.map((choice) => {
        if (choice.minimum !== undefined) {
            const rangeChoice = choice;
            ranges.push(new numericRangesExports.Range(rangeChoice.minimum, rangeChoice.maximum, rangeChoice.increment));
        }
        else {
            const listChoice = choice;
            const key = listChoice.key;
            const keyAsNumber = parseFloat(key);
            if (isNaN(keyAsNumber)) {
                console.error(`Choice ${key} cannot be converted to range`);
                return;
            }
            // Create a range that has the same minimal and maximum to represent discrete values
            ranges.push(new numericRangesExports.Range(keyAsNumber, keyAsNumber, 1));
        }
    });
    return ranges;
};
const buildRangesType = (ranges) => {
    return numericRangesExports.RangeConverter.toRanges(ranges);
};

export { buildRangesType, validateRangeInput };
//# sourceMappingURL=rangedAttribute.mjs.map
